var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24.0002L46.8257 31.4167C48.7923 25.363 48.2737 18.7759 45.384 13.1045C42.4942 7.43311 37.4701 3.14178 31.4165 1.17447C29.0257 0.377831 26.52 -0.0195178 24 -0.00161844V24.0002Z",
    fill: "#73C7A9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.0001V-0.00170898C17.6343 -0.00170898 11.5293 2.52704 7.02813 7.02825C2.52692 11.5295 -0.00183105 17.6344 -0.00183105 24.0001C-0.00183105 30.3658 2.52692 36.4707 7.02813 40.9719C11.5293 45.4731 17.6343 48.0019 24 48.0019C29.0819 48.058 34.0467 46.475 38.1582 43.4876C42.2697 40.5002 45.309 36.2673 46.8257 31.4166L24 24.0001Z",
    fill: "#73C7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.e819925a5bf81e3ae212ac2fdc1004a1.svg";
export { ForwardRef as ReactComponent };